import styled from "styled-components";

export const LayoutWrapper = styled.main`
  margin: 20px 0 0 62px;    
`;
